import { render, staticRenderFns } from "./ThirdTab.vue?vue&type=template&id=0563bf6f"
import script from "./ThirdTab.vue?vue&type=script&lang=js"
export * from "./ThirdTab.vue?vue&type=script&lang=js"
import style0 from "./ThirdTab.vue?vue&type=style&index=0&id=0563bf6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
